// src/pages/dashboard/DashboardPage.jsx
import React, {useState} from 'react';
import { Box, Heading, SimpleGrid } from '@chakra-ui/react';
import WeightSummary from '../../components/dashboard/Weight/WeightSummary';
import GoalsSummary from '../../components/dashboard/Goals/GoalsSummary';
import WeeklyInsights from '../../components/dashboard/WeeklyInsights/WeeklyInsights';

export default function DashboardPage() {
    return (
        <Box as="main" p={8}>
            <Heading mb={6}>Welcome back!</Heading>

            {/* Weekly Insights at Top */}
            <Box mb={8} p={6} bg="white" rounded="lg" shadow="sm">
                <WeeklyInsights />
            </Box>

            {/* Trends Grid */}
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} mb={8}>
                <Box p={6} bg="gray.50" rounded="lg">
                    <GoalsSummary />
                </Box>
                <Box p={6} bg="white" rounded="lg" shadow="sm">
                    <WeightSummary />
                </Box>
            </SimpleGrid>
        </Box>
    );
}